import { render, staticRenderFns } from "./brand-active.vue?vue&type=template&id=1b4e2fab"
import script from "./brand-active.vue?vue&type=script&lang=js"
export * from "./brand-active.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports